<i18n src="@/locales/modules/RequestTypeTranslate.json"></i18n>

<template>
	<el-dialog
		append-to-body
		class="custom-dialog request-type-statistical-expression-dialog"
		:visible.sync="isDialogActiveLocal"
		:title="$t('StatisticalExpression')"
	>
		<PerfectScrollbar>
			<div class="p-6">
				<vs-table
					class="stack-table"
					:data="value"
					:max-items="itemsPerPage"
					:pagination="!!value.length"
					:noDataText="$t('Notify.NoDataAvailable')"
					@selected="id => isEditable && $emit('onClickEditItem', id)"
				>
					<div slot="header" class="flex flex-grow justify-end">
						<vs-button class="w-1/2 md:w-1/3 max-w-xs font-bold" type="filled" v-if="isEditable" @click="$emit('onClickAddNew')">{{ $t("Actions.AddNew") }}</vs-button>
					</div>

					<template slot-scope="{ data }">
						<tbody>
							<vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" :class="{ 'cursor-default': !isEditable }">
								<vs-td>{{ tr.name }}</vs-td>
								<vs-td>{{ tr.type_object.value }}</vs-td>
								<vs-td>{{ tr.expression }}</vs-td>
								<vs-td class="whitespace-no-wrap text-right">
									<i class="nucleo nucleo-edit mr-3" v-if="isEditable" @click.stop="$emit('onClickEditItem', tr)"></i>
									<i class="nucleo nucleo-trash-can" v-if="isEditable" @click.stop="showDeleteConfirm(tr.id)"></i>
								</vs-td>
							</vs-tr>
						</tbody>
					</template>
				</vs-table>
			</div>
		</PerfectScrollbar>
	</el-dialog>
</template>

<script>
import { showConfirm } from "@/mixins/mixins.js";

export default {
	mixins: [showConfirm],
	name: "RequestTypeStatisticalExpressionDialog",
	props: {
		value: {
			type: Array,
			default() {
				return [];
			}
		},
		isDialogActive: {
			type: Boolean,
			required: true
		},
		isEditable: {
			type: Boolean,
			default: false
		}
	},
	emits: {
		closeDialog: {
			required: true
		},
		onClickAddNew: {
			required: true
		},
		onClickEditItem: {
			required: true
		},
		onClickDeleteItem: {
			required: true
		},
	},
	data() {
		return {

			selected: [],
			itemsPerPage: 10,
		};
	},
	computed: {
		isDialogActiveLocal: {
			get() {
				return this.isDialogActive;
			},
			set(val) {
				if (!val) {
					this.$emit("closeDialog");
				}
			}
		},
	},
	methods: {
		showDeleteConfirm(id) {
			this.mixinShowConfirm().then(isAccept => {
				if (isAccept) {
					this.$emit("onClickDeleteItem", id);
				}
			});
		},
	}
};
</script>

<style lang="scss" scoped>
.request-type-statistical-expression-dialog {
	::v-deep .vs-table--thead {
		display: none;
	}

	::v-deep .vs-table--pagination {
		margin-top: 0;
	}
}
</style>
